"use client";

import { useLocale } from "next-intl";
import type { ChangeEvent } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useLocalStorage } from "utils";
import { useAvailableLocales } from "./useAvailableLocales";

export default function LocaleSwitcher() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  const [, setCurrentLocale] = useLocalStorage<string>("currentLocale", locale);

  const searchParams = useSearchParams();
  const availableLocales = useAvailableLocales();

  function onSelectChange(event: ChangeEvent<HTMLSelectElement>) {
    const nextLocale: string = event.target.value.toString();
    setCurrentLocale(nextLocale);

    const newPath: string = pathname.replace(
      pathname.split("/")[1],
      nextLocale
    );

    const queryString = searchParams.toString();
    const hash = typeof window !== "undefined" ? window.location.hash : "";

    const fullUrl =
      newPath +
      (queryString ? `?${queryString}` : "") +
      hash;

    router.push(fullUrl);
  }

  return (
    <div className="block text-gray-400 ml-11">
      <select
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-xl block w-max p-2 cursor-pointer uppercase"
        value={locale}
        onChange={onSelectChange}
      >
        {availableLocales.map((cur) => (
          <option className="cursor-pointer uppercase" key={cur} value={cur}>
            {cur}
          </option>
        ))}
      </select>
    </div>
  );
}
